import { ECourierPaymentConfirmationStatus } from "../../../Enum/ECourierPaymentConfirmationStatus"

export const StatusBadge = ({ status }: { status: ECourierPaymentConfirmationStatus }) => {
  const classes =
    status === ECourierPaymentConfirmationStatus.Confirmed
      ? "bg-emerald-100 text-emerald-700"
      : status === ECourierPaymentConfirmationStatus.Rejected
        ? "bg-red-50 text-red-700"
        : "bg-amber-50 text-amber-700"

  const label =
    status === ECourierPaymentConfirmationStatus.Confirmed
      ? "Confirmado"
      : status === ECourierPaymentConfirmationStatus.Rejected
        ? "Contestado"
        : "Aguardando"

  return <span className={`rounded-full px-3 py-1 text-xs font-bold ${classes}`}>{label}</span>
}
